import { HttpClient } from '@angular/common/http';
import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

import { CookieService } from 'ngx-cookie-service';
import { ConstantsModule } from '../constants/constants.module';
import { ConnectedPageWithTable } from '../root_classes/connected-page-with-table';
import { UserAddComponent } from '../user-add/user-add.component';
import { UserEditComponent } from '../user-edit/user-edit.component';
import { UserGenerateNewPasswordComponent } from '../user-generate-new-password/user-generate-new-password.component';

@Component({
	selector: 'app-user-list',
	templateUrl: './user-list.component.html',
	styleUrls: ['./user-list.component.scss']
})
export class UserListComponent extends ConnectedPageWithTable implements OnInit {

	public stateChoice: any[] = [];
	public roleChoice: any[] = [];

	constructor(constantsModule: ConstantsModule, cookieService: CookieService, httpClient: HttpClient, router: Router, modalService: NgbModal) {
		super(constantsModule, cookieService, httpClient, router, modalService);

		// Creating filter list.
		this.stateChoice = [
			{label: "Actif", value:'A'},
			{label: "Désactivé", value:'D'},
			{label: "Société désactivée", value:'SD'},
		];
		this.roleChoice = [
			{label: "Utilisateur", value:"U"},
			{label: "Ingénieur", value:"I"},
			{label: "Administrateur", value:"A"}
		];
	}

	ngOnInit(): void {
		// Preparing the list of columns.
		this.setColumns([
			{field:"username", header:"Identifiant", sort:"username"},
			{field:"role", header:"Rôle", sort:"role"},
			{field:"name", header:"Nom", sort: "name"},
			{field:"firstname", header:"Prénom", sort: "firstname"},
			{field:"active", header:"Etat", sort: "active"},
			{field:"companyname", header: "Société", sort: "company_name"},
		]);

		// Loading data from the server.
		this.loadData("/api/user-list");
	}

	// FONCTIONS UTILITAIRES.
	public filterColumns(event: Event): string {
		return (<HTMLInputElement> event.target).value;
	}

	// ACTIONS.
	public doEdit(userId: string, username: string, companyName: string): void {
		this.runModalDialogWithParameters(UserEditComponent, {id: userId, username: username, companyName: companyName},
			(result: any) => {
				if (result == "FERMETURE") return;

				switch (result) {
					case "UNAUTHORIZED":
						this.alertLine.alertDangerMessage = "Vous ne disposez pas des droits d'édition.";
						break;
					case "CANNOT CREATE ENTITY":
						this.alertLine.alertDangerMessage = "Erreur de création de la base de données. Contactez votre administrateur.";
						break;
					case "NOT FOUND":
						this.alertLine.alertDangerMessage = "Impossible de trouver l'utilisateur à éditer. Merci de recommencer l'opération.";
						break;
					case "DATABASE":
						this.alertLine.alertDangerMessage = "Erreur d'accès à la base de données. Contactez votre administrateur.";
						break;
					case "CANNOT UPDATE ENTITY":
						this.alertLine.alertDangerMessage = "Erreur de la mise à jour de la base de données. Contactez votre administrateur.";
						break;
					default:
						this.alertLine.alertDangerMessage = "Erreur inconnue (" + result.VALUE + "). Contactez votre administrateur.";
						break;
				}
			},
			(reason: any) => {
				// Test if click outside or press space bar the dialog.
				if (reason != 1 && reason != 0) {

					for(var userIndex in this.getData()) {
						var user = this.getDataItem(userIndex);
						if (user._id == reason.id) {
							user.name = reason.name.trim().toUpperCase();
							user.firstname = reason.firstname.charAt(0).toUpperCase() + reason.firstname.trim().slice(1);
							user.role = reason.role;
							user.company_id = reason.company;
							user.company_name = reason.company_name;
							user.company_active = reason.company_active;
							user.global_active = reason.global_active;
							break;
						}
					}

					// Updating the sorting.
					this.filterData();
					// Message informatif.
					this.alertLine.alertSuccessMessage = "Utilisateur modifié.";
				}
			}
		);
	}

	public doActivate(userId: string): void {
		// Sending activation to the server.
		var newData = {
			"userid": userId
		};

		this.put("/api/user-activate", newData,
			(response:any) => {
				if (response.DATA == "ERR") {
					this.alertLine.alertDangerMessage = "Impossible d'activer l'utilisateur.";
				} else {
					this.alertLine.alertSuccessMessage = "Utilisateur activé.";

					// Replacing the state on the list.
					for(var userIndex in this.getData()) {
						var user = this.getDataItem(userIndex);
						if (user._id == userId) {
							user.active = true;
							user.global_active = response.GLOBAL_ACTIVE;
							break;
						}
					}

					// Filtering again datas.
					this.filterData();
				}
			},
			(err:any) => {
				this.alertLine.alertDangerMessage = "Impossible d'activer l'utilisateur.";
			}
		);
	}

	public doDeactivate(userId: string): void {
		// Sending deactivation to the server.
		var newData = {
			"userid": userId
		};
		this.put("/api/user-deactivate", newData,
			(response: any) => {
				if (response.DATA == "ERR") {
					this.alertLine.alertDangerMessage = "Impossible de désactiver l'utilisateur.";
				} else {
					this.alertLine.alertSuccessMessage = "Utilisateur désactivé.";

					// Replacing the state on the list.
					for(var userIndex in this.getData()) {
						var user = this.getDataItem(userIndex);
						if (user._id == userId) {
							user.active = false;
							user.global_active = response.GLOBAL_ACTIVE;
							break;
						}
					}

					// Filtering again datas.
					this.filterData();
				}
			},
			(err: any) => {
				this.alertLine.alertDangerMessage = "Impossible de désactiver l'utilisateur.";
			}
		);
	}

	public doGenerateNewPassword(userId: string, userName: string): void {
		this.runModalDialogWithParameters(UserGenerateNewPasswordComponent, {id: userId, username:userName},
			(result:any) => {
				if (result == "FERMETURE") return;
				this.alertLine.alertDangerMessage = "Impossible de réinitialiser le mot de passe. Contactez votre administrateur.";
			},
			(reason:any) => {
				if (reason != 1 && reason != 0) {
					this.alertLine.alertSuccessMessage = "Mot de passe réinitialisé.";
				}
			}
		);
	}

	public doAdd(): void {
		this.runModalDialog(UserAddComponent,
			(result: any) => {
				if (result == "FERMETURE") return;

				switch (result) {
					case "UNAUTHORIZED":
						this.alertLine.alertDangerMessage = "Vous ne disposez pas des droits d'édition.";
						break;
					case "DATABASE":
						this.alertLine.alertDangerMessage = "Erreur de base de données. Contactez votre administrateur.";
						break;
					case "MAIL FORMAT":
						this.alertLine.alertDangerMessage = "Impossible d'ajouter l'utilisateur: L'identifiant saisi est incorrect.";
						break;
					case "ENTITY ALREADY EXISTS":
						this.alertLine.alertDangerMessage = "Impossible d'ajouter l'utilisateur: L'utilisateur existe déjà.";
						break;
					case "CANNOT CREATE ENTITY":
						this.alertLine.alertDangerMessage = "Erreur de création de la base de données. Contactez votre administrateur.";
						break;
         			default:
						this.alertLine.alertDangerMessage = "Erreur inconnue (" + result.VALUE + "). Contactez votre administrateur.";
						break;
				}
			},
			(reason: any) => {
				// Test if click outside or press space bar the dialog.
				if (reason != 1 && reason != 0) {
					// Inserting new item inside the list.
					var newUser = {
						"_id": reason["_id"],
						"role": reason["role"],
						"username": reason["username"],
						"active": reason["active"],
						"name": reason["name"],
						"firstname": reason["firstname"],
						"company_id": reason["company_id"],
						"global_active": reason["global_active"],
						"company_name": reason["company_name"],
					};

					// Updating for sorting.
					this.datas = [ ...this.datas, newUser ];

					// Filtering again datas.
					this.filterData();

					// Message informatif.
					this.alertLine.alertSuccessMessage = "Utilisateur ajouté.";
				}
			}
		);
	}
}
